import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatDataService {
  // BehaviorSubject stores the latest value and emits it to new subscribers
  private toWebsocket = new BehaviorSubject<any>(null);
  private fromWebsocket = new BehaviorSubject<any>(null);

  // Observable that components can subscribe to
  toWebsocket$: Observable<any> = this.toWebsocket.asObservable();
  fromWebsocket$: Observable<any> = this.fromWebsocket.asObservable();

  // Persisted independently so late subscribers (e.g. chat component navigated to after connect) don't miss it
  private _generalChatId: string | null = null;

  constructor() {}

  setGeneralChatId(id: string | null) { this._generalChatId = id; }
  getGeneralChatId(): string | null { return this._generalChatId; }

  // Send data to other components
  sendToWebsocket(data: any) {
    this.toWebsocket.next(data);
  }

  sendFromWebsocket(data: any) {
    this.fromWebsocket.next(data);
  }
}
